// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //serviceBase : 'http://localhost:20746/',
 // serviceBase : 'http://devsandbox01.energi.com:8089/', //'http://localhost:20746/',
	serviceBase : 'https://api.telematicexchange.com/TelematicsAPI/',//demo api 
	//serviceBase : 'https://teleapi01.telematicexchange.com/TelematicsAPI/', //prod api
  //serviceBase : 'https://devaws.telematicexchange.com/', //aws dev api proxy
  isTest : true,
  convertAPIKey: 'kzCDlZbqBVTgHbIACOLPCe9MwrQVJcWi'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

